import { Component, OnInit, HostListener, ViewEncapsulation } from '@angular/core';
import { NotificationService } from './notifications.service';
import { NotificationModel, GetNotificationsQuerys } from './notification.models';
import { SnackbarService } from '../shared/components/snackbar/service/snackbar.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent implements OnInit {
  public showOrdenar = false;
  public showFilter = false;
  public showActions = false;
  public asChecked = false;
  public checkAll = false;
  public items: NotificationModel[] = [];
  public dateFilter = {
    to: null,
    from: null
  };
  public nextPage = '';
  public loadingMessages = false;
  public loadingMoreMessages = false;

  @HostListener('window:scroll', ['$event'])
  doSomething(ev): void {
    const bounding = document.getElementById(`last-message`).getBoundingClientRect();
    if (
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    ) {
      this.getMoreNotifications(this.nextPage);
    }
  }

  constructor(
    private notificationService: NotificationService,
    private snackbarService: SnackbarService
    ) { }

  ngOnInit() {
    this.getNotifications({order: 'date:DESC'});
  }

  getNotifications(query?: GetNotificationsQuerys) {
    const dateFilter = this.checkDateFilter();
    query = { ...query, ...dateFilter, page_items: 50 };
    this.items = [];
    this.loadingMessages = true;
    this.notificationService.getNotifications(query).subscribe(resp => {
      this.items = resp.payload;
      this.nextPage = resp.links.next;
      this.checkAll = false;
      this.asChecked = false;
      this.loadingMessages = false;
    }, (_) => this.loadingMessages = false);
  }

  clickMessage(note) {
    if (note.url) {
      window.open(note.url, '_blank');
    }
  }

  checkAllClick() {
    this.items.forEach(item => item.checked = this.checkAll);
    this.asChecked = this.checkAll;
  }

  checkDateFilter(): GetNotificationsQuerys {
    if (!this.dateFilter.from && !this.dateFilter.to) {
      return;
    }
    let query: GetNotificationsQuerys = {};
    if (this.dateFilter.to) {
      query.to = this.notificationService.formatDate(this.dateFilter.to, true);
    }
    if (this.dateFilter.from) {
      query.from = this.notificationService.formatDate(this.dateFilter.from, false);
    }
    return query;
  }

  clearDateFilter() {
    this.dateFilter = {
      to: null,
      from: null
    };
    this.getNotifications();
  }

  setAsChecked() {
    if (this.items.some(e => e.checked)) {
      this.asChecked = true;
    } else {
      this.asChecked = false;
    }

    if (this.items.some(e => !e.checked)) {
      this.checkAll = false;
    } else {
      this.checkAll = true;
    }
  }

  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.dateFilter.to) {
      return false;
    }
    return (startValue.getTime()) > this.dateFilter.to.getTime();
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.dateFilter.from) {
      return false;
    }
    return (endValue.getTime() + 86400000) <= this.dateFilter.from.getTime();
  }

  readAction(readState: boolean) {
    this.showActions = false;
    const readItems = [];
    this.items.forEach(item => {
      if (item.checked === true) {
        readItems.push(
          {
            id: item.id,
            read: readState,
            cleared: true
          }
        );
      }
    });

    this.notificationService.readMessage(readItems).subscribe(() => {
      this.dateFilter = {
        to: null,
        from: null
      };
      this.snackbarService.show('Sua solicitação esta sendo processada', 'warning');
      this.getNotifications({order: 'date:DESC'});
    });
  }

  getMoreNotifications(link) {
    if (this.loadingMoreMessages || !this.nextPage) {
      return false;
    }
    this.loadingMoreMessages = true;
    this.notificationService.getNextPageNotifications(link).subscribe(resp => {
      this.items = this.items.concat(resp.payload);
      this.nextPage = resp.links.next;
      this.loadingMoreMessages = false;
    },
      err => { this.loadingMoreMessages = false; });
  }
}
